import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  useUpdatePlanMenuCloseDimensionByOrderLineMutation,
  useUpdatePlanMenuCloseDimensionMutation,
} from 'core/api/PlanMenuCloseDimensionApi'
import {
  AppNotification,
  NotificationType,
} from 'components/notification/Notification'
import { SelectPopup } from 'components/SelectPopup'
import { UniversalSelectItem } from '../FrozeMillet/FrozeMillet'
import { useGetBuffetMilletQuery } from 'core/api/BuffetMilletApi'
import {
  IBuffetMilletDto,
  IBuffetMilletRequest,
} from 'core/api/dto/BuffetMilletDto'

interface IPopupProps {
  setIsShowPopup: (arg: boolean) => void
  isOneDimension: boolean
  dimensionId?: string | null
  dishId?: string | null
}

const AddMilletPopup = ({
  setIsShowPopup,
  isOneDimension,
  dimensionId,
  dishId,
}: IPopupProps) => {
  const { t } = useTranslation()
  const [updatePlanMenuCloseDimension] =
    useUpdatePlanMenuCloseDimensionMutation()

  const [updatePlanMenuCloseDimensionByOrderLine] =
    useUpdatePlanMenuCloseDimensionByOrderLineMutation()

  const [currentMillet, setCurrentMillet] = useState<IBuffetMilletDto | null>(
    null,
  )
  const [milletList, setMilletList] = useState<IBuffetMilletDto[]>([])
  const [inputValue, setInputValue] = useState<string>('')

  const [params, setParams] = useState<IBuffetMilletRequest>({
    limit: 10,
    offset: 0,
    search: '',
    is_archived: false,
  })

  const { data: dataMillet } = useGetBuffetMilletQuery({
    ...params,
  })

  // Фильтрация/поиск
  useEffect(() => {
    const handler = setTimeout(() => {
      setParams({
        limit: 10,
        offset: 0,
        search: inputValue,
        is_archived: false,
      })
    }, 500)
    return () => clearTimeout(handler)
  }, [inputValue])

  // Обновление списка при подгрузке
  useEffect(() => {
    if (!dataMillet) return

    if (params.offset === 0) {
      setMilletList(dataMillet.results)
    } else {
      setMilletList((prev) => [...prev, ...dataMillet.results])
    }
  }, [dataMillet])

  // Подгрузка следующей страницы
  const nextPageHandler = () => {
    setParams((prev) => ({
      ...prev,
      offset: (prev.offset || 0) + 10,
    }))
  }

  // Сохранение выбранной тары
  const saveMillet = (selectedItem: IBuffetMilletDto) => {
    if (!selectedItem) return

    if (isOneDimension && dimensionId) {
      updatePlanMenuCloseDimension({
        id: Number(dimensionId),
        data: { millet: selectedItem.id },
      })
        .unwrap()
        .then(() => {
          AppNotification({
            msg: t('Тара добавлена'),
            type: NotificationType.success,
          })
          setIsShowPopup(false)
        })
    }

    if (!isOneDimension && dishId) {
      updatePlanMenuCloseDimensionByOrderLine({
        orderLineId: Number(dishId),
        data: { millet: selectedItem.id },
      })
        .unwrap()
        .then(() => {
          AppNotification({
            msg: t('Тара добавлена'),
            type: NotificationType.success,
          })
          setIsShowPopup(false)
        })
    }
  }

  return (
    <SelectPopup
      title={t('Выбор тары')}
      items={milletList}
      selectedId={currentMillet?.id}
      renderItem={(item, selected, onClick) => (
        <UniversalSelectItem
          data={item}
          onClick={() => {
            setCurrentMillet(item)
            onClick()
          }}
          isSelected={selected}
          getTitle={(data) => data.name}
          getSubtitle={() => t('Наименование тары')}
          getDescription={(data) => `${data.weight} ${t('кг')}`}
          getImage={(data) => data.imageOnS3 || data.image || null}
        />
      )}
      onSave={(item) => saveMillet(item)}
      onClose={() => setIsShowPopup(false)}
      hasMore={!!dataMillet?.next}
      onLoadMore={nextPageHandler}
      searchable={true}
      inputValue={inputValue}
      onInputChange={setInputValue}
    />
  )
}

export default AddMilletPopup
